// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

export const SCHEDULING_PARAMETERS_EXTENSION_URL = 'https://medplum.com/fhir/StructureDefinition/SchedulingParameters';
export const SERVICE_TYPE_REFERENCE_EXTENSION_URL = 'https://medplum.com/fhir/service-type-reference';
export const FHIR_TIMEZONE_EXTENSION_URL = 'http://hl7.org/fhir/StructureDefinition/timezone';
export const V2_OVERRIDE_TAG_SYSTEM = 'https://polarissleep.com/scheduling-engine';
export const V2_OVERRIDE_TAG_CODE = 'medplum-v2-availability-override';
export const POLARIS_ENV_TAG_SYSTEM = 'https://polarissleep.com/env';
export const AVAILABILITY_BLOCK_CREATED_BY_EXTENSION_URL =
  'https://polarissleep.com/fhir/StructureDefinition/availability-block-created-by';
